import React from "react";
import { useVatReport } from "./VatReportProvider.js";
import { Alert } from "../../../../packages/ui/Alert.js";
import { FormattedAmount } from "../FormattedAmount.js";
import { VAT_CREDIT } from "../../../model/accounting/templates/taxes/VatCredit.js";
import { VAT_DEBT } from "../../../model/accounting/templates/taxes/VatDebt.js";
import { getLastDateOfMonth } from "../../../model/accounting/date/getLastDateOfMonth.js";
import { formatAmount } from "../../../model/accounting/formatAmount.js";

/**
 * Renders potential VAT warnings.
 */
export const VatReportWarnings = () => {
  const { report } = useVatReport();

  if (!report) {
    return null;
  }

  const isVatReturned = report.vatAccountBalance < 0;

  const templateId = isVatReturned ? VAT_CREDIT.id : VAT_DEBT.id;
  const amount = Math.abs(report.vatAccountBalance);
  const date = getLastDateOfMonth(report.year, report.month);

  const formUrl = `/template/${templateId}?Date=${date}&Amount=${formatAmount(amount)}`;

  return (
    <>
      {report.vatAccountBalance !== 0 && (
        <p>
          <Alert type="warning">
            Käibemaksu konto saldo pole 0 (<FormattedAmount cents={report.vatAccountBalance} />
            )! Käibemaksu kandmine ettemaksuks või maksuvõlaks: <a href={formUrl}>siin</a>.
          </Alert>
        </p>
      )}
    </>
  );
};
